import {
  FormControl,
  FormControlLabelProps,
  FormHelperText,
  InputLabel,
  InputLabelProps,
  MenuItem,
  MenuItemProps,
} from "@mui/material";
import Select, { SelectChangeEvent, SelectProps } from "@mui/material/Select";
import React from "react";
import { Controller } from "react-hook-form";
import { RhfOption } from "./types/RhfOption";
import { RhfProps } from "./types/RhfProps";
import { RhfStyleProps } from "./types/RhfStyleProps";
import Label from "./ui/Label";
import { useTranslation } from "react-i18next";

type Props = RhfProps &
  RhfStyleProps &
  SelectProps & {
    label?: React.ReactNode;

    onChange?: (
      event: SelectChangeEvent<unknown>,
      child: React.ReactNode
    ) => void;

    options?: RhfOption[] | string[] | object[];
    children?: React.ReactNode;

    displayMember?: string;
    valueMember?: string;

    showErrorText?: boolean;

    selectProps?: SelectProps;
    formControlLabelProps?: FormControlLabelProps;
    InputLabelProps?: InputLabelProps;
    menuItemProps?: MenuItemProps;
  };

const RhfSelect = ({
  rhf,
  name,
  defaultValue,
  rules, // RhfProps
  sx,
  className,
  style, // RhfStyleProps
  label,
  onChange,
  options,
  children,
  displayMember,
  valueMember,

  showErrorText,

  selectProps,
  formControlLabelProps,
  InputLabelProps,
  menuItemProps,
  ...restProps
}: Props) => {
  // if (row == null) {
  //     row = true;// 預設橫向排列
  // }
  const { t } = useTranslation();

  if (displayMember == null) {
    displayMember = "label";
  }

  if (valueMember == null) {
    valueMember = "value";
  }

  if (showErrorText == null) {
    showErrorText = true; // 預設顯示錯誤訊息
  }

  return (
    <Controller
      control={rhf?.control}
      name={name}
      defaultValue={defaultValue == null ? "" : String(defaultValue)}
      rules={rules}
      render={({ field, fieldState }) => {
        // 等同於: render={({ field: { onChange, onBlur, value, ref } }) => (

        const has_error = !!fieldState.error;

        return (
          <FormControl
            error={showErrorText && has_error}
            // sx={{ ...{ minWidth: "256px" }, ...sx }}
            sx={{
              ...{
                minWidth:
                  sx == null || (sx as any).width == null ? "256px" : undefined,
              }, // 沒設定寬度時給一個最小寬度
              ...sx,
            }}
            className={className}
            style={style}
          >
            {label == null ? undefined : (
              <InputLabel {...InputLabelProps}>{label}</InputLabel>
            )}
            <Select
              {...selectProps}
              {...restProps}
              // size={size}
              label={label}
              // 強制修正線穿過文字的問題，但可能只能用outline??:  https://github.com/mui/material-ui/issues/21394
              // input={<OutlinedInput notched label={label} />}

              {...field} // 等同於: onChange={onChange} onBlur={onBlur} value={value} ref={ref}
              value={field.value}
              renderValue={(value) => value}
              onChange={(e) => {
                field.onChange(e.target.value); // RHF
                onChange?.(e, e.target.value); // 自己設定的onChange
              }}
            >
              {options == null
                ? undefined
                : options?.map((option: any) => {
                    if (typeof option === "string") {
                      option = { value: option, label: option };
                    }

                    const val = String(option[valueMember as string]);
                    const lbl = option[displayMember as string];

                    const key = `${name}.${val}`;

                    return (
                      <MenuItem {...menuItemProps} key={key} value={val}>
                        {typeof lbl === "string" ? (
                          <Label
                            text={
                              lbl === ""
                                ? " " /*如果為空字串，多補上空格，高度才會正常*/
                                : lbl
                            }
                          />
                        ) : (
                          lbl
                        )}
                      </MenuItem>
                    );
                  })}
              {children}
            </Select>
            {showErrorText && has_error ? (
              <FormHelperText error={true}>
                {has_error ? t(fieldState.error?.message ?? "") : ""}
              </FormHelperText>
            ) : (
              <></>
            )}
          </FormControl>
        );
      }}
    />
  );
};

export default RhfSelect;

// controlled 元件 如果要做 OneHot 模式
// <RhfRadioButton rhf={rhf}
//     key={key} name={rdo_name}
//     value={val} label={lbl}
//     markProps={markProps}
//     formControlLabelProps={formControlLabelProps}
// />
